// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Boolean
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.notification.NotificationPayload

@OptIn(InternalKtorfitApi::class)
public class _NotificationServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : NotificationService {
  override fun fetchNotifications(isRead: Boolean): Flow<NotificationPayload> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "notifications/")
        isRead?.let{ parameter("isRead", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<NotificationPayload>>(),)!! 
  }
}

public class _NotificationServiceProvider : ClassProvider<NotificationService> {
  override fun create(_ktorfit: Ktorfit): NotificationService = _NotificationServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createNotificationService(): NotificationService = _NotificationServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
